"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defined = void 0;
function defined(properties) {
    var definedProps = {};
    Object.keys(properties).map(function (key) {
        if (properties[key] !== undefined) {
            definedProps[key] = properties[key];
        }
    });
    return definedProps;
}
exports.defined = defined;
